import { observable, makeObservable } from 'mobx';
import PerformanceReviewQuestion from './PerformanceReviewQuestion';
import {QAAnswer} from 'main/stores/questions';

class PerformanceReviewAnswer extends QAAnswer {
  value;
  _relations = {
    question: PerformanceReviewQuestion
  };

  constructor(other) {
    super();

    makeObservable(this, {
      value: observable
    });

    this.merge(other);
  }
}

export default PerformanceReviewAnswer;
